export const uk = {
    timezone: 'Часовой пояс'
};
